import { z } from 'zod'

export const recoverySessionDataSchema = z.object({
  accessToken: z.string().min(1),
  refreshToken: z.string().min(1),
  accessTokenExpiresIn: z.number().positive().finite(),
  refreshTokenExpiresIn: z.number().positive().finite(),
  userId: z.union([z.string().min(1), z.number().int().positive().safe()]).transform(String),
  // Legacy profile tokens may be empty; access and refresh remain independently required.
  userToken: z.string(),
})

export type RecoveredAuthSession = z.infer<typeof recoverySessionDataSchema>
